var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67873 1.8211L8.17912 4.32149L2.74963 9.75098L0.520329 9.99708C0.221892 10.0301 -0.0302566 9.77774 0.00294649 9.4793L0.250993 7.24844L5.67873 1.8211ZM9.7256 1.44883L8.55158 0.274811C8.18537 -0.0914001 7.59142 -0.0914001 7.22521 0.274811L6.12072 1.3793L8.62111 3.87969L9.7256 2.7752C10.0918 2.40879 10.0918 1.81504 9.7256 1.44883Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.5b17c501cb80472512be70bb325c19bd.svg";
export { ForwardRef as ReactComponent };